








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PersonalRelationDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxPersonalRelation extends Vue {
  private types: PersonalRelationDto[] | null = [];
  public selectedType = new PersonalRelationDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: PersonalRelationDto) {
    this.$emit("personalRelationSelected", type);
  }

  public setSelected(type: PersonalRelationDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .personalRelation_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
